import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-hidden text-dark inline-flex align-items-baseline" }
const _hoisted_2 = { class: "text-ellipsis" }
const _hoisted_3 = { class: "font-bold text-ellipsis" }

import { toRefs } from 'vue';

interface PropsInterface {
  name: string | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DisplayChatName',
  props: {
    name: {}
  },
  setup(__props: any) {

const props = __props;
const { name } = toRefs(props);

const getCustomName = () => {
  return name.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(getCustomName()), 1)
    ])
  ]))
}
}

})